export const sizeClasses = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-3 text-base',
  lg: 'px-6 py-3 text-lg',
  xl: 'px-8 py-4 text-xl',
  '2xl': 'px-10 py-5 text-2xl'
}

export const labelSizeClasses = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
  xl: 'text-lg'
}

export const buttonPositionClasses = {
  sm: 'inset-y-1',
  md: 'inset-y-2',
  lg: 'inset-y-3',
  xl: 'inset-y-4'
}

export const hintSizeClasses = {
  sm: 'text-xs mt-1',
  md: 'text-sm mt-1',
  lg: 'text-base mt-2',
  xl: 'text-lg mt-3'
}

// Form styling utilities
export const getFormPaddingClasses = (config: any) => {
  return {
    container: config?.theme?.form?.padding?.container || 'py-8 px-4 sm:px-10',
    field: config?.theme?.form?.padding?.field || 'space-y-4'
  }
}

export const getFormRoundingClasses = (config: any) => {
  return {
    button: config?.theme?.form?.rounding?.button || 'rounded-md',
    input: config?.theme?.form?.rounding?.input || 'rounded-md'
  }
} 